<template>
  <div>
    <div class="buttons">
      <el-button type="text" @click="open">删除</el-button>
      <el-button type="primary" @click="submit">保存</el-button>
    </div>
    <div class="seckill_xinxi">
      <h3>活动信息</h3>
      <el-form ref="form" :model="form" style="margin-left:40px;" label-width="140px">
        <el-form-item label="活动名称" :required="true">
          <el-input
            style="width:450px;"
            placeholder="请填写活动名称，最多30字"
            maxlength="30"
            v-model="activeName"
          ></el-input>
        </el-form-item>

        <el-form-item label="活动时间" :required="true">
          <el-date-picker
            v-model="value1"
            type="datetimerange"
            range-separator="至"
            unlink-panels
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="订单取消">
          <div class="label_box">
            买家
            <el-input
              style="width:150px; margin:0 10px;"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              placeholder="请输入"
              v-model="cancelDuration"
            ></el-input>分钟未支付订单，订单取消
            <p>系统默认为15分钟。订单取消时间最小设置为2分钟，最大设置时间为30分钟</p>
          </div>
        </el-form-item>
      </el-form>
      <div class></div>
    </div>
    <div class="good_setting">
      <h3>商品设置</h3>
      <el-form label-position="right" label-width="140px">
        <div style="margin-left:40px; padding-top:40px;" v-for="(item,index) in list" :key="index">
          <el-form-item label="秒杀商品" :required="true">
            <el-input
              style="width:600px;"
              placeholder="请填写活动名称，最多30字"
              maxlength="30"
              v-model="item.name"
            >
              <el-button slot="append" @click="selectProducts">选择商品</el-button>
            </el-input>
            <span style="color:red; cursor:pointer; margin-left:50px;" @click="delGood(index)">删除商品</span>
          </el-form-item>
          <el-form-item label="秒杀价格、数量" :required="true">
            <table class="good_set_table" border="1">
              <thead>
                <td>规格</td>
                <td>售价(元)</td>
                <td>秒杀价(元)</td>
                <td>库存</td>
                <td>秒杀数量</td>
              </thead>
              <tr>
                <td>默认</td>
                <td>{{item.price}}</td>
                <td>
                  <input
                    class="inp"
                    type="text"
                    placeholder="请输入"
                    maxlength="30"
                    v-model="item.priceSpike"
                    :class="{borderStyle:item.priceSpikeShow}"
                    @change="rule(item,index)"
                  />
                </td>
                <td>{{item.stock}}</td>
                <td>
                  <input
                    class="inp"
                    type="text"
                    placeholder="请输入"
                    maxlength="30"
                    onkeyup="value=value.replace(/[^\d]/g,'')"
                    v-model="item.numSpike"
                    :class="{borderStyle:item.numSpikeShow}"
                    @change="rule1(item,index)"
                  />
                </td>
              </tr>
            </table>
          </el-form-item>
          <el-form-item label="秒杀价格、数量">
            <el-checkbox v-model="item.restrictions">开启限购</el-checkbox>
            <el-input
              style="width:300px; margin-left:20px;"
              placeholder="请填写整数"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              maxlength="30"
              v-model="item.restrictionsNum"
            ></el-input>
          </el-form-item>
          <div style="border-bottom:1px solid #000"></div>
        </div>
      </el-form>
      <el-button
        style="margin-left:40px;padding:10px 80px; margin-top:30px;"
        @click="selectProducts"
      >添加秒杀商品</el-button>
    </div>
    <!-- 弹窗商品列表 -->
    <el-dialog title="选择商品" :visible.sync="centerDialogVisible" width="60%" center>
      <div style="margin:20px 0;">
        <el-input
          style="width:300px;"
          placeholder="请输入商品名称\编码"
          maxlength="30"
          v-model="searchValue"
        ></el-input>
        <el-button type="primary" @click="getGoodList(1)">搜索</el-button>
        <el-button type="info" @click="reset">重置</el-button>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" prop="goodName" label="商品名称"></el-table-column>
        <el-table-column align="center" prop="price" label="售价" width="180"></el-table-column>
        <el-table-column align="center" prop="stock" label="库存" width="180"></el-table-column>
        <el-table-column align="center" prop="address" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="addsgood(scope.row)">选择商品</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="pageFn()"
        layout="prev, pager, next"
        :current-page.sync="currentPage"
        :page-size="10"
        :total="goodsCount"
      ></el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getSeckillGood, editSeckill, getSeckillDetails } from "@/api/goods";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      form: {
        name: 123,
      },
      value1: null,
      centerDialogVisible: false,
      list: [
        {
          price: 0,
          name: "",
          stock: 0,
          priceSpike: "",
          numSpike: "",
          restrictions: false,
          restrictionsNum: "",
          priceSpikeShow: false,
          numSpikeShow: false,
        },
      ],
      listPush: true,
      tableData: [],
      searchValue: "",
      activeName: "",
      cancelDuration: 15, //未支付订单自动取消时间
      goods: [
        {
          goodId: "",
          goodName: "",
          seckillPrice: "",
          stockCount: "",
        },
      ],
      goodsCount: 10,
      currentPage: 1,
      activeNameShow: false,
      activityId: null,
    };
  },
  computed: {
    ...mapGetters(["chooseCompany", "companyList", "mchId"]),
  },
  mounted() {
    this.activityId = this.$route.query.id;
    this.getData();
  },
  methods: {
    getData() {
      let that = this;
      getSeckillDetails(this.activityId).then((res) => {
        console.log(res.data);
        that.activeName = res.data.activityName;
        that.cancelDuration = res.data.cancelDuration;
        that.value1 = [];
        that.value1.push(new Date(Number(res.data.startTime)));
        that.value1.push(new Date(Number(res.data.endTime)));
        that.list = [];
        res.data.goodSeckillDTOList.forEach((item) => {
          let good = {
            price: item.goodPrice / 100,
            name: item.goodName,
            id: data.goodId,
            stock: data.stock,
            priceSpike: item.seckillPrice,
            numSpike: "",
            restrictions: false,
            restrictionsNum: "",
            priceSpikeShow: false,
            numSpikeShow: false,
          };
        });
      });
    },
    selectProducts() {
      this.centerDialogVisible = true;
      this.getGoodList();
    },
    reset(){
        this.searchValue = "";
        this.getGoodList();
    },
    getGoodList(page) {
      let mchId = this.chooseCompany.id;
      let data = {
        pageCount: 10,
        page: this.currentPage,
        goodName:this.searchValue,
        mchId:mchId
      };
      if(page){
        console.log(1)
        data.page = page;
      }
      getSeckillGood(data).then((res) => {
        let count = res.data.pop();
        if (typeof count != "undefined") {
          this.goodsCount = count.goodsCount;
        }
        this.tableData = res.data;
      });
    },
    addsgood(data) {
      let door = true;
      this.list.forEach((item) => {
        if (item.id == data.goodId) {
          this.$message({
            message: "此活动已添加该商品",
            type: "warning",
          });
          door = false;
        }
      });
      if (this.listPush && door) {
        this.listPush = false;
        this.list = [
          {
            price: data.price / 100,
            name: data.goodName,
            id: data.goodId,
            stock: data.stock,
            priceSpike: "",
            numSpike: "",
            restrictions: false,
            restrictionsNum: "",
            priceSpikeShow: false,
            numSpikeShow: false,
          },
        ];
        this.centerDialogVisible = false;
      } else if (!this.listPush && door) {
        this.list.push({
          price: data.price / 100,
          name: data.goodName,
          id: data.goodId,
          stock: data.stock,
          priceSpike: "",
          numSpike: "",
          restrictions: false,
          restrictionsNum: "",
          priceSpikeShow: false,
          numSpikeShow: false,
        });
        this.centerDialogVisible = false;
      }
    },
    // 取消添加返回上一页
    open() {
      this.$confirm("是否删除本次活动", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.$router.go(-1);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 删除商品
    delGood(i) {
      this.list.splice(i, 1);
    },
    rule(val, index) {
      console.log(val);
      if (isNaN(val.priceSpike)) {
        this.$message({
          type: "info",
          message: "请填写正确的价格",
        });
        this.list[index].priceSpikeShow = true;
      } else if (Number(val.priceSpike) > val.price) {
        this.$message({
          type: "info",
          message: "秒杀价格不得超出原价",
        });
        this.list[index].priceSpikeShow = true;
      } else {
        this.list[index].priceSpikeShow = false;
      }
    },
    rule1(val, index) {
      if (val.numSpike == "") {
        this.$message({
          type: "info",
          message: "填写秒杀价",
        });
        this.list[index].numSpikeShow = true;
      } else if (Number(val.numSpike) > val.stock) {
        this.$message({
          type: "info",
          message: "秒杀价格不得超出原价",
        });
        this.list[index].numSpikeShow = true;
      } else {
        this.list[index].numSpikeShow = false;
      }
    },
    submit() {
      if (this.activeName == "") {
        this.$message({
          type: "info",
          message: "请填写活动名称",
        });
        return;
      } else if (!this.value1) {
        this.$message({
          type: "info",
          message: "请填写活动时间",
        });
        return;
      } else if (this.list.length < 1) {
        this.$message({
          type: "info",
          message: "请添加秒杀商品",
        });
        return;
      } else {
        let x = true;
        this.list.forEach((item) => {
          if (typeof item.id == "undefined") {
            this.$message({
              type: "info",
              message: "请选择商品",
            });
            console.log(222);
            x = false;
          } else if (item.priceSpike == "") {
            this.$message({
              type: "info",
              message: "填写秒杀价",
            });
            item.priceSpikeShow = true;
            x = false;
          } else if (item.numSpike == "") {
            this.$message({
              type: "info",
              message: "填写秒杀数量",
            });
            item.numSpikeShow = true;
            x = false;
          } else if (Number(item.priceSpike) > item.price) {
            this.$message({
              type: "info",
              message: "秒杀价格不得超出原价",
            });
            item.priceSpikeShow = true;
            x = false;
          } else if (Number(item.numSpike) > item.stock) {
            this.$message({
              type: "info",
              message: "秒杀数量不得超出库存数",
            });
            item.numSpikeShow = true;
            x = false;
          } else if (isNaN(item.priceSpike)) {
            this.$message({
              type: "info",
              message: "请填写正确的价格",
            });
            item.priceSpikeShow = true;
            x = false;
          }
        });
        if (!x) {
          return;
        }
      }
      let mchId = this.chooseCompany.id;
      let data = {
        activityId:this.activityId,
        activityName: this.activeName,
        cancelDuration: this.cancelDuration,
        endTime: "",
        startTime: "",
        mchId:mchId,
        goodSeckillDTOList: [],
      };
      data.startTime = this.value1[0].getTime();
      data.endTime = this.value1[1].getTime();
      this.list.forEach((item) => {
        let arr = {
          goodId: item.id,
          stockCount: item.numSpike,
          seckillPrice: item.priceSpike * 100,
          maxSale: -1,
        };
        if (item.restrictions) {
          arr.maxSale = item.restrictionsNum;
        }
        data.goodSeckillDTOList.push(arr);
      });
      editSeckill(data).then((res) => {
        this.$message({
          message: "添加成功",
          type: "success",
        });
        this.$router.go(-1);
      });
    },
    pageFn() {
      console.log(789);

      this.getGoodList();
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
}
.buttons {
  margin: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;

  button {
    width: 120px;
  }
}
.seckill_xinxi {
  background-color: #e4e9ec;
  padding: 20px;

  .label_box {
    position: relative;

    p {
      position: absolute;
      left: 0;
      top: 40px;
      margin: 0;
      color: #7f7f7f;
      font-size: 12px;
    }
  }
}
.good_setting {
  background-color: #e4e9ec;
  padding: 20px;
  margin-top: 20px;

  .good_set_table {
    td {
      width: 200px;
      text-align: center;
      padding: 5px;
    }
  }
}
table,
table tr th,
table tr td {
  border: 1px solid #666;
}
table {
  min-height: 25px;
  line-height: 25px;
  text-align: center;
  border-collapse: collapse;
}
.inp {
  width: 80px;
  border: 1px solid #eee;
  outline: skyblue;
  padding: 10px;
  border-radius: 4px;
}
.borderStyle {
  border: 1px solid red;
}
</style>


// WEBPACK FOOTER //
// src/pages/seckill/editSeckill.vue